import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="bg-brand-deepBrown text-white pt-12 md:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          <div className="col-span-2 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4 md:mb-6">
              <img
                src={process.env.PUBLIC_URL + "/logo.png"}
                alt="Capilano Consulting"
                className="h-16 sm:h-20 md:h-28 lg:h-32 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-white/60 text-xs sm:text-sm leading-relaxed mb-5 md:mb-6 max-w-sm">
              Transforming businesses through strategic consulting and innovative solutions worldwide.
            </p>
            <div className="flex gap-3">
              {[
                { icon: <FaFacebookF />, href: "/" },
                { icon: <FaTwitter />, href: "/" },
                { icon: <FaLinkedinIn />, href: "/" },
                { icon: <FaInstagram />, href: "/" },
              ].map((s, i) => (
                <Link
                  key={i}
                  to={s.href}
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-brand-orange hover:text-white transition-all duration-300 text-sm"
                >
                  {s.icon}
                </Link>
              ))}
            </div>
          </div>

          <div className="col-span-1">
            <h4 className="font-serif text-base sm:text-lg font-bold mb-4 md:mb-6 relative pb-2 sm:pb-3 after:absolute after:bottom-0 after:left-0 after:w-8 sm:after:w-10 after:h-[2px] after:bg-brand-orange">
              Quick Links
            </h4>
            {/* Inside Footer.jsx Quick Links section */}
<ul className="space-y-2.5 sm:space-y-3">
  {[
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Industries", path: "/industries" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ].map((link) => (
    <li key={link.name}>
      <Link
        to={link.path}
        className="text-white/60 text-xs sm:text-sm hover:text-brand-orange transition-colors"
      >
        {link.name}
      </Link>
    </li>
  ))}
</ul>
          </div>

          <div className="col-span-1">
            <h4 className="font-serif text-base sm:text-lg font-bold mb-4 md:mb-6 relative pb-2 sm:pb-3 after:absolute after:bottom-0 after:left-0 after:w-8 sm:after:w-10 after:h-[2px] after:bg-brand-orange">
              Services
            </h4>
            <ul className="space-y-2.5 sm:space-y-3">
              {["Strategic Consulting", "Business Analysis", "Growth Strategy", "Market Expansion"].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="text-white/60 text-xs sm:text-sm hover:text-brand-orange transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 sm:col-span-1 lg:col-span-1">
            <h4 className="font-serif text-base sm:text-lg font-bold mb-4 md:mb-6 relative pb-2 sm:pb-3 after:absolute after:bottom-0 after:left-0 after:w-8 sm:after:w-10 after:h-[2px] after:bg-brand-orange">
              Contact Info
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex gap-3 items-start">
                <FiMapPin className="text-brand-orange mt-1 shrink-0 text-sm sm:text-base" />
                <span className="text-white/60 text-xs sm:text-sm">Dubai, United Arab Emirates</span>
              </li>
              <li className="flex gap-3 items-center">
                <FiMail className="text-brand-orange shrink-0 text-sm sm:text-base" />
                <a href="mailto:email@example.com" className="text-white/60 text-xs sm:text-sm hover:text-brand-orange transition-colors">
                  email@example.com
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <FiPhone className="text-brand-orange shrink-0 text-sm sm:text-base" />
                <a href="tel:0000000000" className="text-white/60 text-xs sm:text-sm hover:text-brand-orange transition-colors">
                  (000) 000-0000
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="text-white/40 text-xs sm:text-sm">
            © {new Date().getFullYear()} Capilano Consulting. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/contact" className="text-white/40 text-xs sm:text-sm hover:text-brand-orange transition-colors">
              Privacy Policy
            </Link>
            <Link to="/contact" className="text-white/40 text-xs sm:text-sm hover:text-brand-orange transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;